const equipmentmodels = {
	title: "Modeller",
	stitle: "Modell",
	new_title: "Ny modell",
	edit_title: "Endre modell: {name}",
	list_title: "Modelliste",
	list_subtitle: "Endre modell",
	id: "ID",
	name: "Navn",
	status: "Status",
	reference_id: "Referanse",
};
export default equipmentmodels;